export default __webpack_public_path__ + "static/media/background.0c84a5d8.svg";